<template>
  <div class="row">
    <div class="col-sm-12">
      <h4 class="text-center text-primary">
        <b>Cambiar datos de acceso al sistema.</b>
      </h4>
      <div class="form-group" :class="{'has-error': validation.hasError('datos.login')}">
        <div class="input-group input-group-sm">
          <div class="input-group-addon"> <span class="text-danger">*</span> Usuario:</div>
           <input type="text" v-model.trim="datos.login" class="form-control" placeholder="Login de acceso actual">
        </div>
        <div class="error" v-if="validation.hasError('datos.login')"> {{validation.firstError('datos.login')}} </div>
      </div>

      <div class="form-group" :class="{'has-error': validation.hasError('datos.password')}">
        <div class="input-group input-group-sm">
          <div class="input-group-addon"> <span class="text-danger">*</span> Clave actual: </div>
           <input type="text" v-model.trim="datos.password" class="form-control" placeholder="Clave actual">
        </div>
        <div class="error" v-if="validation.hasError('datos.password')"> {{validation.firstError('datos.password')}} </div>
      </div>

      <div class="form-group" :class="{'has-error': validation.hasError('datos.clave')}">
        <p class="text-center mb-1 green--text">Establecer la nueva clave de acceso:</p>
        <div class="clave-help">
          <v-icon small color="light-blue darken-2">mdi-information-outline</v-icon>
          <span>Use solo letras y numeros. No se permiten espacios ni simbolos especiales, luego vuelva a ingresar con sus nuevos datos.</span>
        </div>
        <div class="input-group input-group-sm">
          <div class="input-group-addon"> <span class="text-danger">*</span> Clave Nueva:</div>
           <input type="text" v-model.trim="datos.clave" class="form-control" placeholder="Su nueva clave">
        </div>
        <div class="error" v-if="validation.hasError('datos.clave')"> {{validation.firstError('datos.clave')}} </div>
      </div>

      <Alertas ref="alertar" />
      <button class="btn btn-sm btn-azul center-block" @click="actualizar()" :disabled="$store.state.cambiarMisDatosAcceso==false"> Actualizar datos </button>
    </div>

    <notifications group="auth" position="bottom right" />    
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import Alertas from '@/components/AAlertas.vue';
import {parseJsonError} from '@/components/Utils.js'
import {getUserData,setUserData} from '@/accessToken.js'  
import gql from 'graphql-tag';
export default {
  data(){
    return{
      datos:{
        login: null,
        password: null,
        clave: null,
      }
    }
  },
  components:{Alertas},
  validators: {
    'datos.login'(value){ return Validator.value(value).minLength(5).required(); },
    'datos.clave'(value){ return Validator.value(value).minLength(5).required(); },
    'datos.password'(value){ return Validator.value(value).minLength(5).required(); },
  },
  methods:{
    cargarLoginActual(){
      const raw = getUserData();
      if (!raw) return;
      try {
        const userData = JSON.parse(raw);
        this.datos.login = userData && userData.user ? userData.user : this.datos.login;
      } catch (e) {
        window.console.error(e);
      }
    },
    actualizar(){
      const ex = getUserData(); 
      if( ex ){ 
        const userdata = this.$store.state.DATA_USER;
        if( (this.datos.clave+'').startsWith(userdata.num_doc) ){
          this.$refs.alertar.invalido( "No puede usar su documento como subcadena inicial de la nueva clave." ); 
          return;
        }
      }
      this.$validate().then((success) => {
        var obj = window.Object.assign( {},this.datos );
        if (success) {
          // estas acciones van en par, set el objeto para luego limpiar campos nulos
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');

          this.$refs.alertar.cargando();
          window.console.log( "SSSSS",window.stringifyObject(obj) );
          this.enviarDatos( obj );
        }else{
          window.console.log( "HHHHH",window.stringifyObject(obj) );
          this.$refs.alertar.invalido( "Revise los datos" );
        }
      });
    },
    async enviarDatos( obj ){
      var vue = this;
      var sql = gql`mutation{ cambiarMisDatosAcceso(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      window.console.log( sql )

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        if(data.data.cambiarMisDatosAcceso.ok){
          vue.$refs.alertar.success();
          setUserData(vue.datos.login, vue.datos.clave);
          vue.$emit("onaccesschange");
        }else{
          var errores = JSON.stringify(data.data.cambiarMisDatosAcceso.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.$refs.alertar.invalido( vals );
        }
        window.console.log(data);
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        window.console.error(window.stringifyObject(error));
        this.$notify( parseJsonError( error,'cambiarMisDatosAcceso' ) )
      })
    }
  },
  mounted(){
    this.cargarLoginActual();
  }
}
</script>

<style scoped>
.clave-help {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px 10px;
  margin: 0 0 8px;
  border: 1px solid #d5ecfb;
  border-radius: 8px;
  background: #f5fbff;
  color: #36576f;
  font-size: 12px;
  line-height: 1.35;
}

.clave-help span {
  flex: 1;
}
</style>
